import React from 'react';
import { View, XStack, YStack } from 'tamagui';

import { type ColorTokenKey } from '../../themes/SmoothieColorTokens';
import { Shadows } from '../Shadows';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    LabelRegular,
} from '../text/Typography';

const DEFAULT_ACCENT_COLOR: ColorTokenKey = '$petal';

export interface GoalSetSectionItem {
    label?: string;
    emphasizedText: string;
    rightText: string;
    dotColor?: ColorTokenKey;
}

export interface GoalSetSectionProps {
    number: number;
    title: string;
    items: GoalSetSectionItem[];
    accentColor?: ColorTokenKey;
}

export const GoalSetSection = ({
    number,
    title,
    items,
    accentColor = DEFAULT_ACCENT_COLOR,
}: GoalSetSectionProps) => {
    return (
        <YStack
            width="100%"
            backgroundColor="rgba(255, 255, 255, 0.5)"
            borderRadius={16}
            borderWidth={1}
            borderColor="$white"
            overflow="hidden"
            {...Shadows.MEDIUM}
        >
            <XStack
                paddingHorizontal={16}
                paddingVertical={8}
                alignItems="center"
                gap={16}
                backgroundColor="rgba(255, 255, 255, 0.50)"
                borderBottomWidth={1}
                borderBottomColor="$white"
            >
                <View
                    width={24}
                    height={24}
                    borderRadius={8}
                    backgroundColor="$white"
                    alignItems="center"
                    justifyContent="center"
                >
                    <BodyMediumEmphasized color={accentColor}>
                        {number}
                    </BodyMediumEmphasized>
                </View>
                <BodyMediumRegular>{title}</BodyMediumRegular>
            </XStack>
            {items.map((item, index) => (
                <XStack
                    key={`${item.emphasizedText}-${index}`}
                    alignItems="center"
                    gap={16}
                    paddingHorizontal={16}
                    paddingVertical={8}
                    height={72}
                    borderBottomWidth={index < items.length - 1 ? 1 : 0}
                    borderBottomColor="$white"
                >
                    <View
                        width={24}
                        height={24}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <View
                            width={8}
                            height={8}
                            borderRadius={4}
                            backgroundColor={item.dotColor ?? accentColor}
                        />
                    </View>
                    <YStack flex={1}>
                        {item.label != null && (
                            <LabelRegular>{item.label}</LabelRegular>
                        )}
                        <BodyMediumEmphasized>
                            {item.emphasizedText}
                        </BodyMediumEmphasized>
                    </YStack>
                    <View
                        paddingHorizontal={12}
                        paddingVertical={8}
                        borderRadius={16}
                        backgroundColor="$white"
                    >
                        <LabelRegular color="$gray1000">
                            {item.rightText}
                        </LabelRegular>
                    </View>
                </XStack>
            ))}
        </YStack>
    );
};
